<script>
import { useMainStore } from '../../../../stores/index';
export default {
  name: 'profile_img',
  setup () {
    const StoreAll = useMainStore();
    return {
      Store: StoreAll
    };
  },
  props: {
    img: {
      type: String,
      required: true
    }
  }
};
</script>
<template>
<div class='d-flex justify-content-center col-sm mb-5' style='width: 100%;height: 200px;'>
    <div class="d-grid">
        <img :src='$userAvatar(img)' alt='Foto de perfil' style='width: 200px; height: 200px; object-fit: cover; border-radius: 50%; border: 1px solid #0D6EFD;'>
    </div>
</div>
</template>
